import React from 'react';

const InclusiveIcon = () => {
    return (
        <svg width="800px" height="800px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" >

        <path d="M0 0h48v48H0z" fill="none"/>
        <g id="Shopicon">
            <path d="M17,22c1.274,0,2.473-0.305,3.542-0.835c-2.66-2.167-4.361-5.466-4.361-9.165c0-2.176,0.598-4.208,1.624-5.959
                C17.541,6.014,17.272,6,17,6c-4.418,0-8,3.582-8,8S12.582,22,17,22z"/>
            <circle cx="28" cy="12" r="7.819"/>
            <path d="M30,24c-5.952,0-10.813,1.913-12.9,4.777c-1.05-0.914-1.862-1.813-2.3-2.379c-1.986-2.643-5.754-3.181-8.4-1.198
                c-2.646,1.984-3.185,5.753-1.199,8.4C5.519,34.025,13.131,44,24,44h20V32C44,27.439,37.981,24,30,24z M8.4,31.2
                c-0.662-0.882-0.482-2.139,0.397-2.8c0.36-0.27,0.783-0.399,1.201-0.399c0.608,0,1.207,0.274,1.596,0.791
                C11.647,28.864,17.026,36,24,36h8v-2l0,0v-2h-8c-1.229,0-2.46-0.385-3.61-0.962C21.518,29.573,25.025,28,30,28
                c6.104,0,10,2.369,10,4v8h-2H24C15.107,40,8.669,31.559,8.4,31.2z"/>
        </g>
        </svg>
    );
};

export default InclusiveIcon;